'use strict';
// 1. Знаходимо всі елементи з класом "population"
var populationSpans = document.querySelectorAll('.population');
var totalDisplay = document.querySelector('.total-population');
var averageDisplay = document.querySelector('.average-population');
var total = 0;
// 2. Перебираємо елементи та збираємо дані
populationSpans.forEach(function(span) {
    // Видаляємо коми, щоб JavaScript міг сприйняти це як число
    var number = Number(span.textContent.replace(/,/g, ''));
    if (!isNaN(number)) total += number;
});
// 3. Рахуємо середнє значення
var count = populationSpans.length;
var average = count > 0 ? total / count : 0;
// 4. Форматуємо числа з роздільником (комами) та виводимо в HTML
// toLocaleString('en-US') зробить формат "1,234,567"
totalDisplay.textContent = total.toLocaleString('en-US');
averageDisplay.textContent = Math.round(average).toLocaleString('en-US');

//# sourceMappingURL=js_get_data_DOM.a33e0a18.js.map
